import { render, staticRenderFns } from "./BuyBackAddress.vue?vue&type=template&id=7de95fc8&scoped=true"
import script from "./BuyBackAddress.vue?vue&type=script&lang=js"
export * from "./BuyBackAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de95fc8",
  null
  
)

/* custom blocks */
import block0 from "./BuyBackAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports